/**
 * 使用HMAC-SHA256算法生成消息签名
 * @param key 密钥字符串
 * @param message 要签名的消息字符串
 * @returns 十六进制格式的签名字符串
 */
async function hmacSha256(keyString: string, messageString: string): Promise<string> {
  // 1. 将密钥和消息转换为 ArrayBuffer
  const encoder = new TextEncoder();
  const keyBuffer = encoder.encode(keyString);
  const messageBuffer = encoder.encode(messageString);

  // 2. 导入密钥
  // 'raw' 格式表示密钥是原始字节序列
  // 'HMAC' 算法指定了密钥的用途
  // extractable: false 表示密钥不能被导出（增加安全性）
  // usages: ['sign'] 表示密钥只能用于签名操作
  const key = await crypto.subtle.importKey(
    'raw',
    keyBuffer,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );

  // 3. 使用密钥和消息生成 HMAC 签名
  // 'HMAC' 算法和 'SHA-256' 哈希算法
  const signature = await crypto.subtle.sign(
    { name: 'HMAC', hash: 'SHA-256' },
    key,
    messageBuffer
  );

  // 4. 将 ArrayBuffer 签名的结果转换为十六进制字符串
  // 这是一种常见的表示哈希值的方式
  const hashArray = Array.from(new Uint8Array(signature));
  const hexHash = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  return hexHash;
}

export async function getPasswordHash(password: string) {
  return hmacSha256('meiyuji', password);
}